import {IntegrationType} from "@/shared/timrTypes";
import {AddisonSyncConfigDialog} from "./addisonSyncConfigDialog";
import {Integrations} from "../integrations";
import {PanelBase} from "./panelBase";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import {AddisonOrganization} from "@/shared/timr";

export interface AddisonSyncConfig {
	activeOrganizations: AddisonOrganization[];
}

export class AddisonSync extends PanelBase {

	constructor() {
		// Required for custom elements
		super();
	}

	// Called when the element is inserted in the DOM
	// DEVNOTE: No shadow DOM here, so we can use external css
	private connectedCallback() {
		this.innerHTML = this.renderPanel({
			logoHtml: `<img src="/timr/images/integrations/addison_sync.svg" alt="Addison Sync" height="36px">`,
			topActionsHtml: this.renderEditActionButton()
		});
		this.initListeners();
		this.updateBanner();
	}

	private initListeners() {
		$(this).find("#edit").on("click", () => {
			AddisonSyncConfigDialog.edit(this._integration, this._integration.configuration as AddisonSyncConfig);
		});
		this.querySelector("[data-delete-integration]").addEventListener("click", () => {
			BootstrapModal.confirm({
				title: messages["dialog.delete.confirm"],
				message: messages["integrations.addisonSync.delete.message"],
				yesAction: (confirmModal) => {
					confirmModal.close();
					Integrations.triggerDeletedIntegrationEvent(IntegrationType.ADDISON_SYNC, this.integration.id);
				}
			});
		});
	}

	protected updateBanner(): void {
	}

	public onIntegrationAdded() {
		window.location.href = "/timr/integrations/addison-sync/auth.html";
	}
}
